class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');
        const resultsMarkup = doc.querySelector('#shopify-section-predictive-search').innerHTML;

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = resultsMarkup;

        const searchTermLower = searchTerm.trim().toLowerCase();
        const productList = tempDiv.querySelector('.ps-right ul');

        if (productList) {
          const items = Array.from(productList.querySelectorAll('li'));

          items.sort((a, b) => {
            const titleA = a.querySelector('.ps-title')?.textContent.trim().toLowerCase() || '';
            const titleB = b.querySelector('.ps-title')?.textContent.trim().toLowerCase() || '';

            const aStarts = titleA.startsWith(searchTermLower) ? 0 : 1;
            const bStarts = titleB.startsWith(searchTermLower) ? 0 : 1;

            return aStarts - bStarts;
          });

          items.forEach(item => productList.appendChild(item));
        }

        this.predictiveSearchResults.innerHTML = tempDiv.innerHTML;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);